import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import HomePage from './components/HomePage';
import VideoPage from './components/VideoPage';
import AdminDashboard from './components/AdminDashboard';
import AdminLogin from './components/AdminLogin';
import DmcaPage from './components/DmcaPage';
import TermsPage from './components/TermsPage';
import PrivacyPage from './components/PrivacyPage';
import ContactPage from './components/ContactPage';
import { Toaster } from '@/components/ui/sonner';

function App() {
  useEffect(() => {
    // Popup Ad System - Opens https://ads.usexxx.com/pop.php on any click once every 20 minutes
    const POPUP_URL = 'https://ads.usexxx.com/pop.php';
    const POPUP_INTERVAL = 20 * 60 * 1000; // 20 minutes in milliseconds
    const STORAGE_KEY = 'lastPopupTime';

    const handleClick = (e) => {
      // Don't trigger on admin pages
      if (window.location.pathname.startsWith('/admin')) {
        return;
      }

      // Check last popup time
      const lastPopupTime = localStorage.getItem(STORAGE_KEY);
      const currentTime = new Date().getTime();

      if (!lastPopupTime || (currentTime - parseInt(lastPopupTime)) > POPUP_INTERVAL) {
        // Open popup in new tab
        try {
          const popup = window.open(POPUP_URL, '_blank');
          
          // If popup was blocked, try opening in same tab with delay
          if (!popup || popup.closed || typeof popup.closed === 'undefined') {
            console.log('Popup blocked, will try on next click');
          } else {
            // Update last popup time
            localStorage.setItem(STORAGE_KEY, currentTime.toString());
            console.log('Popup ad opened successfully');
          }
        } catch (error) {
          console.error('Error opening popup:', error);
        }
      }
    };

    // Add click listener to document
    document.addEventListener('click', handleClick);

    // Cleanup
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  return (
    <div className="App min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/video/:id" element={<VideoPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/*" element={<AdminDashboard />} />
          <Route path="/dmca" element={<DmcaPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
